import { types } from './types';
import { instance } from '../utils';
import { sortAdditionalObligations } from '../../util/sorters';
import { triggerLoading } from '../forms/actions';
import { triggerNotification } from '../../components';
import { addDoc, getDocumentsByObligations } from '../documents/actions';

export const getInternalObligationsByUserAndOrg = (user, orgId) => dispatch => {
  return new Promise((resolve, reject) => {
    const url = `/api/extra/getInternalObligations`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`
    };
    const payload = {
      userId: user.userId,
      orgId: orgId
    };
    dispatch(triggerLoading(true));
    dispatch({ type: types.SET_INTERNAL_OBLIGATIONS.START });
    instance
      .post(url, payload, { headers })
      .then(response => {
        dispatch({
          type: types.SET_INTERNAL_OBLIGATIONS.SUCCESS,
          payload: sortAdditionalObligations(response.data)
        });
        console.debug("PASSED",response.data);
        dispatch(triggerLoading(false));
        resolve(response.data);
      })
      .catch(error => {
        dispatch({ type: types.SET_INTERNAL_OBLIGATIONS.ERROR, payload: error.message });
        triggerNotification({
          message: "Error",
          description: error.message,
          status: "Error"
        });
        dispatch(triggerLoading(false));
        reject(error);
      });
  });
};

export const getInternalObligationsByUserAndOrgOnAddNew = (user, orgId) => dispatch => {
  return new Promise((resolve, reject) => {
    const url = `/api/extra/getInternalObligations`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`
    };
    const payload = {
      userId: user.userId,
      orgId: orgId,
    };
    dispatch(triggerLoading(true));
    dispatch({ type: types.SET_INTERNAL_OBLIGATIONS.START });
    instance
      .post(url, payload, { headers })
      .then(response => {
        dispatch({
          type: types.SET_INTERNAL_OBLIGATIONS.SUCCESS,
          payload: sortAdditionalObligations(response.data)
        });
        dispatch(triggerLoading(false));
        resolve(response.data);
      })
      .catch(error => {
        dispatch({ type: types.SET_INTERNAL_OBLIGATIONS.ERROR, payload: error.message });
        triggerNotification({
          message: "Error",
          description: error.message,
          status: "Error",
        });
        dispatch(triggerLoading(false));
        reject(error);
      });
  });
};

export const createInternalObligation = ({payload, user, organizationId, callback}) => dispatch => {
  const url = `/api/extra/${organizationId}/createExtra`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.CREATE_INTERNAL_OBLIGATION.START });
  instance
  .post(url, payload, { headers })
  .then(response => {
    dispatch({ type: types.CREATE_INTERNAL_OBLIGATION.SUCCESS });
    triggerNotification({});
    dispatch({
      type: "SET_NAVIGATE_INTERNAL_ID",
      payload: response.data._id 
    });
    dispatch(addDoc(response.data._id));
    return dispatch(getInternalObligationsByUserAndOrgOnAddNew(user, organizationId));
  })
  .then(() => {
    callback(true);
  })
  .catch(error => {
    dispatch({ type: types.CREATE_INTERNAL_OBLIGATION.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  })
  .finally(() =>
    dispatch(triggerLoading(false))
  )
};

export const updateInternalObligation = ({ obligation, formData, user, callback, emailCallback }) => dispatch => {
  const url = `/api/extra/${obligation._id}/${obligation.organization}/uploadToFolder`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${user.token}`
  };
  dispatch({ type: types.UPDATE_INTERNAL_OBLIGATION.START });
  instance
    .post(url, formData, { headers })
    .then(response => {
      dispatch({ type: types.UPDATE_INTERNAL_OBLIGATION.SUCCESS });
      triggerNotification({});
      emailCallback(response.data?.emails ?? [])
      return dispatch(getInternalObligationsByUserAndOrg(user, obligation.organization)); 
    })
    .then(() => {
      callback(true);
    })
    .catch(error => {
      dispatch({
        type: types.UPDATE_INTERNAL_OBLIGATION.ERROR,
        payload: error.message
      });
      triggerNotification({
        message: "Error",
        description: error.message,
        status: "Error"
      });
      callback(true);
    });
};

export const assignInternalUser = ({ newItem, user, organizationId, callback }) => dispatch => {
  const url = `/api/extra/${newItem._id}/assignInternalUser`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  };
  dispatch({ type: types.ASSIGN_INTERNAL_USER.START });
  dispatch(triggerLoading(true));
  instance
    .patch(url, newItem, { headers })
    .then(response => {
      dispatch({ type: types.ASSIGN_INTERNAL_USER.SUCCESS });
      triggerNotification({});
      return dispatch(getInternalObligationsByUserAndOrg(user, organizationId)); 
    })
    .then(() => {
      callback(true);
    })
    .catch(error => {
      dispatch({ type: types.ASSIGN_INTERNAL_USER.ERROR, payload: error.message });
      triggerNotification({
        message: "Error",
        description: error.message,
        status: "Error"
      });
    });
  };

export const massAssignInternalObligations = ({targetUserId, oblIds, user, organizationId, callback}) => dispatch => {
  const url = `/api/extra/massAssignInternalObligations`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  const body ={
    targetUserId,
    items: oblIds,
  }
  dispatch({ type: types.MASS_ASSIGN_INTERNAL_OBLIGATIONS.START });
  instance
  .post(url, body, { headers })
  .then(response => {
    dispatch({ type: types.MASS_ASSIGN_INTERNAL_OBLIGATIONS.SUCCESS });
    triggerNotification({});
    dispatch(getInternalObligationsByUserAndOrg(user, organizationId));
    callback(false); 
  })
  .catch(error => {
    dispatch({ type: types.MASS_ASSIGN_INTERNAL_OBLIGATIONS.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  })
}

export const deleteInternalObligation = (obligation, orgId, user) => dispatch => {
  const url = `/api/extra/${obligation._id}/${obligation.organization}/deleteExtra`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.DELETE_INTERNAL_OBLIGATION.START });
  instance
  .delete(url, { headers })
  .then(response => {
    dispatch({ type: types.DELETE_INTERNAL_OBLIGATION.SUCCESS, payload: response.data });
    triggerNotification({});
    dispatch(getInternalObligationsByUserAndOrg(user, orgId));
  })
  .catch(error => {
    dispatch({ type: types.DELETE_INTERNAL_OBLIGATION.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  })
}